import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_COURSEOUTLINEASSESSMENT,
  GET_COURSEOUTLINEASSESSMENTS,
  ADD_COURSEOUTLINEASSESSMENT,
  UPDATE_COURSEOUTLINEASSESSMENT,
  DELETE_COURSEOUTLINEASSESSMENT
} from '@/queries/modules/courses/course-outline-assessment';

export async function getCourseOutlineAssessments(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_COURSEOUTLINEASSESSMENTS,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setCourseOutlineAssessments', data.getCourseOutlineAssessments);
      context.commit('setSuccess', null);
      return data.getCourseOutlineAssessments
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getCourseOutlineAssessment(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_COURSEOUTLINEASSESSMENT,
        variables: payload
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setCourseOutlineAssessment', data.getCourseOutlineAssessment);
      context.commit('setSuccess', null);
      return data.getCourseOutlineAssessment
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addCourseOutlineAssessment(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_COURSEOUTLINEASSESSMENT,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const courseOutlineAssessments = [...context.state.courseOutlineAssessments];
      courseOutlineAssessments.push(data.addCourseOutlineAssessment);
      context.commit('setCourseOutlineAssessments', courseOutlineAssessments);
      context.commit('setSuccess', newItemSuccess(data.addCourseOutlineAssessment.seq));

      return data.addCourseOutlineAssessment;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateCourseOutlineAssessment(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_COURSEOUTLINEASSESSMENT,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.courseOutlineAssessments.findIndex(item => item.id === data.updateCourseOutlineAssessment.id);
      const courseOutlineAssessments = [
        ...context.state.courseOutlineAssessments.slice(0, index),
        data.updateCourseOutlineAssessment,
        ...context.state.courseOutlineAssessments.slice(index + 1)
      ];
      context.commit('setCourseOutlineAssessments', courseOutlineAssessments);
      context.commit('setSuccess', updateItemSuccess(data.updateCourseOutlineAssessment.seq));

      return data.updateCourseOutlineAssessment
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteCourseOutlineAssessment(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_COURSEOUTLINEASSESSMENT,
        variables: payload,
      });

    const {data, errors} = await result;
    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.courseOutlineAssessments.findIndex(item => item.id === data.deleteCourseOutlineAssessment.id);
      const courseOutlineAssessments = [
        ...context.state.courseOutlineAssessments.slice(0, index),
        ...context.state.courseOutlineAssessments.slice(index + 1)
      ];
      context.commit('setCourseOutlineAssessments', courseOutlineAssessments);
      context.commit('setSuccess', deleteItemSuccess(data.deleteCourseOutlineAssessment.seq));

      return data.deleteCourseOutlineAssessment
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

